import {Component, inject, OnInit, signal} from '@angular/core'
import {ActivatedRoute, Router} from '@angular/router'
import {filter, map, switchMap} from 'rxjs'
import {JsonPipe} from '@angular/common'
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle} from '@angular/material/card'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelDescription,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion'
import {LOCAL_STORAGE} from '../../0-general/providers'
import {AuthService} from '../../services/auth-service'
import {MatButton} from '@angular/material/button'
import {GitlabService} from '../../services/gitlab-service'

@Component({
  selector: 'ohl-logged-in',
  imports: [
    JsonPipe,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
    MatExpansionPanel,
    MatAccordion,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatExpansionPanelHeader,
    MatButton,
    MatCardSubtitle
  ],
  templateUrl: './logged-in.html'
})
export class LoggedIn implements OnInit {
  public readonly self = signal<any | null>(null)

  private route = inject(ActivatedRoute)
  public authService = inject(AuthService)
  private router = inject(Router)
  private storage = inject(LOCAL_STORAGE)
  private gitlabService = inject(GitlabService)

  public ngOnInit() {
    this.route.queryParamMap
      .pipe(
        map(params => params.get('code')),
        filter(Boolean),
        switchMap(code =>
          this.authService.exchange(code, this.storage.getItem('nonce')!))
      )
      .subscribe(self => {
        this.self.set(self)
        this.router.navigate([], {
          queryParams: {'code': null},
          queryParamsHandling: 'merge'
        }).then()
      })
  }

  public getSelf() {
    this.authService.getSelf().subscribe(res => this.self.set(res))
  }

  public refreshToken() {
    this.authService.refresh()
  }

  public listGroups() {
    this.gitlabService.listGroups().subscribe()
  }
}
